import { FormControlLabel, RadioGroup } from '@material-ui/core'
import { fromJS, List, Map } from 'immutable'
import React, { useMemo, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { getValue } from '../../lib/common'
import { PortalCreatableSelect } from '../Main/SelectControls'
import { Radio } from '../Project/UI/Dialog/ConfigureWidget/Radio'
import _ from 'lodash'
import FocusByField from './MapInteractivity/FocusByField'
import FocusByPin from './MapInteractivity/FocusByPin'
import clsx from 'clsx'

export const FOCUS_BY = { PIN: 'pin', FIELD: 'field' }

export default function MapInteractivity({
  disableModal,
  settings,
  onChangeSettings,
  pageUID: pageUIDProvided,
  callerElementUID,
}) {
  const currentPageID = useSelector((state) => state.get('page'))

  const pageUID = useSelector(
    (state) =>
      pageUIDProvided ||
      state
        .getIn(['project', 'Pages'], List())
        .find((page) => page.getIn(['_id']) === currentPageID)
        ?.get?.('uid')
  )

  const page = useSelector((state) =>
    state.getIn(['project', 'Pages'], List()).find((page) => page.getIn(['uid']) === pageUID)
  )

  useEffect(() => {
    onChangeSettings(settings.setIn(['page'], pageUID))
  }, [pageUID])

  const pageID = Map.isMap(page) ? page.getIn(['_id']) : currentPageID

  const mapsByPage = useSelector((state) =>
    state.getIn(['project', 'Pages'], List()).map((page) =>
      state.getIn(['pages', pageID, 'Props', 'elements'], List()).filter((element) => {
        if (element.getIn(['type']) === 'GoogleMap') return true
      })
    )
  )

  const mapsMemo = useMemo(() => {
    const mapsByPageJS = mapsByPage.toJS()
    const mapsElementsIds = _.map(mapsByPageJS, (mapsElements) => _.keys(mapsElements))
    const mapsElementsIdsOptions = _.map(_.flatten(mapsElementsIds), (id) => ({
      value: id,
      label: 'Map ' + id,
      pageID,
    }))
    return mapsElementsIdsOptions
  }, [mapsByPage])

  const focusBy = settings.getIn(['focusBy'], null)

  const handleSelectFocusBy = (e) => {
    onChangeSettings(settings.setIn(['focusBy'], e.target.value))
  }

  const handleFieldLatSelected = (value) => {
    onChangeSettings(settings.setIn(['focusOn', 'field', 'lat'], fromJS({ ...value, pageID })))
  }

  const handleFieldLngSelected = (value) => {
    onChangeSettings(settings.setIn(['focusOn', 'field', 'lng'], fromJS({ ...value, pageID })))
  }

  return (
    <div className="page-conditions-wrap">
      <div className="body-left page-params-wrap">
        <ul>
          <li className={clsx('tablink', 'active')}>
            <label>Focus on</label>
          </li>
        </ul>
      </div>
      <div
        className="body-right page-params-content ft--scroll--content ft--scroll-ya"
        style={{ height: 'auto', padding: '0' }}>
        <div className="custom-parameters-page-body" style={{ overflow: 'hidden' }}>
          <div className="rule-predefined-action element-interactivity">
            <div class="header-content">
              <p class="sub-text">Select focus on coordinates options</p>
            </div>
            <div className="predefined-page-list form-group">
              <label className="form-label">Focus by</label>
            </div>
            <div className="predefined-page-list form-group" style={{ paddingLeft: 8, marginBottom: 8 }}>
              <RadioGroup value={focusBy} onChange={handleSelectFocusBy} className="radio-group-wrap">
                <FormControlLabel
                  classes={{
                    label: 'radio-group-label',
                    disabled: 'radio-group-label-dis',
                  }}
                  value={FOCUS_BY.PIN}
                  control={<Radio className="ft-form-inter-ico" />}
                  label={<>Pin</>}
                />
                <FormControlLabel
                  classes={{
                    label: 'radio-group-label',
                    disabled: 'radio-group-label-dis',
                  }}
                  value={FOCUS_BY.FIELD}
                  control={<Radio className="ft-form-inter-ico" />}
                  label={<>Field</>}
                />
              </RadioGroup>
            </div>

            <div className="predefined-page-list form-group">
              <label className="field-label">Select Map</label>
              <PortalCreatableSelect
                options={mapsMemo}
                menuPortalTarget={document.body}
                isElementStyle={true}
                styles={{
                  indicatorsContainer: {
                    height: '32px',
                  },
                }}
                value={getValue(mapsMemo, settings.getIn(['focusOn', 'map', 'value']))}
                isSearchable
                onChange={(map) => {
                  onChangeSettings(settings.setIn(['focusOn', 'map'], fromJS(map)))
                }}
              />
            </div>

            {focusBy === FOCUS_BY.PIN && (
              <FocusByPin
                settings={settings}
                pageUID={pageUID}
                pageID={pageID}
                onChange={(path, value) => onChangeSettings(settings.setIn(path, fromJS(value)))}
              />
            )}
            {focusBy === FOCUS_BY.FIELD && (
              <FocusByField
                settings={settings}
                pageID={pageID}
                onChangeLat={handleFieldLatSelected}
                onChangeLng={handleFieldLngSelected}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
